import React from 'react';

import { BadgeLabel, type BadgeLabelProps } from '../badges/Badge';
import { type BaseRowProps, Row } from './Row';

export interface BadgeRowProps extends BaseRowProps {
    badgeProps: BadgeLabelProps;
    onPress: () => void; // required
}

/**
 * Row component with a badge label action.
 * Use this for rows that have a secondary action badge.
 */
export const BadgeRow = ({
    badgeProps,
    onPress,
    ...rowProps
}: BadgeRowProps) => {
    return (
        <Row
            {...rowProps}
            onPress={onPress}
            rightContent={<BadgeLabel {...badgeProps} />}
        />
    );
};
